import React from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown } from "aible";

import CapSlider from "components/Project/CapSlider";

import ContinuousRunFrontier from "components/FrontierSliders/ContinuousRunFrontier";

import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import Toggle from "react-toggle";

import styles from "./style.module.css";

export default class ContinuousFrontier extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { frontiers } = this.props;

    const filteredFronters =
      frontiers && frontiers.length > 1 ? frontiers.filter((f) => f.subgroup !== "Overall") : frontiers;

    return (
      <div style={{ width: "100%" }}>
        <div className={styles.fHideHolder}>
          <div className={styles.fHeader}>
            <div className={styles.fHeaderItem} style={{ minWidth: "150px" }}>
              {"Subgroup"}
            </div>
            <div className={styles.fHeaderItem} style={{ flexGrow: 1 }}>
              {"Underpredict"}
            </div>
            <div className={styles.fHeaderItem}>{"Overpredict"}</div>
            <div className={styles.fHeaderItem} style={{ minWidth: "150px", textAlign: "right" }}>
              {"Bias"}
            </div>
          </div>
          <div className={styles.frontierHolder}>
            {filteredFronters.map((f, i) => (
              <div className={styles.frontierRow} key={i}>
                <div className={styles.fGroup}>{f.subgroup}</div>
                <ContinuousRunFrontier
                  frontier={f.frontier}
                  bestModel={
                    f.frontier && f.bestModel
                      ? f.frontier.filter((m) => m.id === f.bestModel.id).length > 0
                        ? f.frontier.filter((m) => m.id === f.bestModel.id)[0]
                        : undefined
                      : undefined
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
